import TrashCan from "@assets/images/trash.svg";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";
import { ItemDetailsEditTabProps } from "@saleor/changeOrderDomestic/components/ItemDetailsTabEdit";
import ModalAddress from "@saleor/changeOrderDomestic/components/ItemDetailsTabEdit/ModalAddress";
import useStyles from "@saleor/changeOrderDomestic/components/ItemDetailsTabEdit/styles";
import ModalInputParameter from "@saleor/changeOrderDomestic/components/ModalInputParameter";
import { WEIGHT_UNIT } from "@saleor/changeOrderDomestic/const";
import {
  getTotalNetPriceByLine,
  getTotalNetPriceByLineNewProductGroup
} from "@saleor/changeOrderDomestic/utils";
import {
  ErrorFields,
  ItemTab
} from "@saleor/changeOrderDomestic/views/ViewEditOrder/types";
import Checkbox from "@saleor/components/Checkbox";
import DatePicker from "@saleor/components/DatePicker";
import DatePickerApplyAll from "@saleor/components/DatePickerApplyAll";
import DecimalFormat from "@saleor/components/DecimalFormat";
import DialogConfirmDelete from "@saleor/components/DialogConfirmDelete";
import MyTypography from "@saleor/components/MyTypography";
import NumberFormat from "@saleor/components/NumberFormat";
import PopoverApplyAll from "@saleor/components/PopoverApplyAll";
import SearchRoute from "@saleor/components/SearchRoute";
import { SingleSelectField } from "@saleor/components/SingleSelectField";
import SingleTextField from "@saleor/components/SingleTextField";
import SingleTextFieldUnblock from "@saleor/components/SingleTextField2";
import StickyHorizontalScrollBar from "@saleor/components/StickyHorizontalScrollBar";
import TableCellHeader from "@saleor/components/TableCellHeader";
import { BIG_ROW_NUMBER_SET } from "@saleor/components/TablePagination/constants";
import { TablePaginationCustom } from "@saleor/components/TablePaginationCustom";
import TextAreaField from "@saleor/components/TextAreaField";
import { REGEX_ONLY_NUMBER, REGEX_ONLY_NUMBER_CHARACTER } from "@saleor/config";
import { checkIsCashSaleOrder } from "@saleor/createOrChangeNotRefContract/utils";
import CashSaleForm from "@saleor/createOrder/components/CashSaleForm";
import { DomesticOrderSortField } from "@saleor/createOrderDomestic/urls";
import FullScreenButton from "@saleor/createOrderExport/components/FullScreenButton";
import {
  OrderType,
  RealtimePartnerType,
  ReasonForChangeRequestDateEnum,
  useDeleteNewlyAddedOrderLineMutation,
  useGet_Realtime_PartnerMutation,
  usePassParameterToIPlanMutation
} from "@saleor/graphql";
import useAppState from "@saleor/hooks/useAppState";
import { renderCollection } from "@saleor/misc";
import { PROD_CATEG_1, SALE_CATEG_1 } from "@saleor/utils/constants";
import { isKO1KO9 } from "@saleor/utils/data/convertUnit";
import { getRandomNumber } from "@saleor/utils/getRandowNumber";
import { getArrowDirection } from "@saleor/utils/sort";
import classNames from "classnames";
import moment from "moment";
import React, { useEffect, useMemo, useRef, useState } from "react";
import SVG from "react-inlinesvg";
import { FormattedNumber, useIntl } from "react-intl";

import {
  DataApplyAllProps,
  DataModalAddressProps,
  typeApplyAll
} from "../ItemDetailsTabEdit/types";

const tabList = [
  {
    id: "order-information-tab",
    code: ItemTab.tabA,
    title: "ข้อมูลสั่งซื้อ",
    index: "z3",
    first: true
  },
  {
    id: "additional-tab",
    code: ItemTab.tabC,
    title: "Additional Data",
    index: "z2",
    first: false
  },
  {
    id: "cash-sale-tab",
    code: ItemTab.tabD,
    title: "Cash Sale",
    index: "z1",
    first: false
  }
];

const AddNewItem: React.FC<ItemDetailsEditTabProps> = props => {
  const {
    soNo,
    dataOrder,
    currentData,
    listLineOrder,
    setListLineOrder,
    loading,
    hasNextPage,
    hasPreviousPage,
    onNextPage,
    onPreviousPage,
    onNextLastPage,
    onPreviousFirstPage,
    onUpdateListSettings,
    settings,
    sort,
    onSort,
    setActiveTab,
    activeTab,
    orderStatus,
    soldToCode,
    onConfirmReloadPage,
    cashSaleFormProps
  } = props;
  const [{ fullScreen }] = useAppState();
  const containerRef = useRef<HTMLDivElement | null>(null);

  const [reRender, setReRender] = useState<boolean>(false);
  const [openDelete, setOpenDelete] = useState<boolean>(false);
  const [itemNoDelete, setItemNoDelete] = useState<string>("");
  const [openAddress, setOpenAddress] = useState<boolean>(false);
  const [dataModalAddress, setDataModalAddress] = useState<
    DataModalAddressProps
  >({ initAddress: "", id: "" });
  const [dataApplyAll, setDataApplyAll] = useState<DataApplyAllProps>({
    anchorEl: null,
    title: "",
    placeholder: "",
    type: null
  });
  const [openApplyAll, setOpenApplyAll] = useState<boolean>(false);
  const [componentKey, setComponentKey] = useState<number>(0);
  const [openInputParameter, setOpenInputParameter] = useState<boolean>(false);
  const [dataInputParameter, setDataInputParameter] = useState<string>(null);

  const classes = useStyles({ activeTab });
  const intl = useIntl();
  const [{ viewEditMode }] = useAppState();
  const isCashSaleOrder = checkIsCashSaleOrder(dataOrder?.orderType);

  const [getShipToData, { data: shipToData }] = useGet_Realtime_PartnerMutation(
    {
      variables: {
        type: RealtimePartnerType.SHIP_TO,
        saleOrgCode: dataOrder?.salesOrg,
        soldToCode,
        piMessageId: getRandomNumber(),
        distributionChannel: dataOrder?.distributionChannel,
        division: dataOrder?.division,
        orderType: OrderType.DOMESTIC
      }
    }
  );

  useEffect(() => {
    if (dataOrder?.salesOrg) {
      getShipToData();
    }
  }, [dataOrder]);

  useEffect(() => {
    if (openAddress) {
      getShipToData();
    }
  }, [openAddress]);

  const isOrderCompletedDelivery = useMemo(
    () => orderStatus === "Completed Delivery",
    [orderStatus]
  );

  const onTabClick = tab => {
    setActiveTab(tab);
  };

  const handleOpenAddress = line => {
    setOpenAddress(true);
    setDataModalAddress({
      initAddress: line.shipTo,
      id: line.itemNo
    });
  };

  const handleCloseAddress = () => {
    setOpenAddress(false);
    setDataModalAddress({ initAddress: "", id: undefined });
  };

  const setApplyPlant = e => {
    if (!isOrderCompletedDelivery) {
      setDataApplyAll({
        type: typeApplyAll.applyPlant,
        title: "Plant",
        placeholder: "ระบุ Plant",
        anchorEl: e.currentTarget,
        maxLength: 4,
        regex: REGEX_ONLY_NUMBER_CHARACTER
      });
      setComponentKey(prev => prev + 1);
      setOpenApplyAll(true);
    }
  };

  const setApplyShippingPoint = e => {
    setDataApplyAll({
      type: typeApplyAll.applyShippingPoint,
      title: "Shipping Point",
      placeholder: "ระบุ Shipping Point",
      anchorEl: e.currentTarget,
      maxLength: 4,
      regex: undefined
    });
    setComponentKey(prev => prev + 1);
    setOpenApplyAll(true);
  };

  const handleApplyAllRequestDate = value => {
    const tempLine = [...listLineOrder];
    tempLine.forEach(item => {
      if (
        !isItemDisabled(item) &&
        !item.hasSplit &&
        !item.isSplit &&
        !isOrderCompletedDelivery
      ) {
        item.requestDate = value;
      }
    });
    setListLineOrder(tempLine);
  };

  useEffect(() => {
    setReRender(prevState => !prevState);
  }, [fullScreen]);

  useEffect(() => {
    setReRender(prevState => !prevState);
    if (containerRef.current) {
      containerRef!.current!.scrollLeft = 0;
    }
  }, [activeTab, viewEditMode]);

  const applyAddressShipTo = value => {
    const tempLine = [...listLineOrder];
    const lineChange = tempLine.find(
      item => item.itemNo === dataModalAddress.id
    );
    lineChange.shipTo = value;
    setListLineOrder(tempLine);
  };

  const handleApplyAll = value => {
    const tempLine = [...listLineOrder];
    if (dataApplyAll.type === typeApplyAll.applyPlant) {
      tempLine.forEach(item => {
        if (!isItemDisabled(item) && !item.hasSplit && !item.isSplit) {
          item.plant = value;
        }
      });
    } else if (dataApplyAll.type === typeApplyAll.applyShippingPoint) {
      tempLine.forEach(item => {
        if (!isItemDisabled(item) && !item.hasSplit && !item.isSplit) {
          item.shippingPoint = value;
        }
      });
    }
    setListLineOrder(tempLine);
    setOpenApplyAll(false);
  };

  const renderInternalAndExternalComment = (key: string, item) =>
    isItemDisabled(item) ? (
      <MyTypography
        variant={"body3"}
        className={classNames(classes.disabledLine, classes.pre)}
      >
        {item[key]}
      </MyTypography>
    ) : (
      <TextAreaField
        maxLength={1320}
        lineLimit={132}
        className={classes.additionaltxtarea}
        verticalResizingOnly
        disabled={item.hasSplit || item.isSplit}
        name={key}
        onChange={e => handleChangeField(e, item.itemNo, key)}
        value={item[key]}
      />
    );

  const handleChangeField = (event, id, field, extraValue?) => {
    const newValue = event.target.value;
    const newList = [...listLineOrder];
    const lineChange = newList.find(item => item.itemNo === id);

    if (field === "quantity") {
      const value = parseInt(event.target.value, 10);
      lineChange.itemQty = value;
      if (lineChange.isSplit) {
        if (lineChange.orderType.substring(0, 3).toUpperCase() === "ATP") {
          const originalId = lineChange.originalId;
          const originLine = newList.find(line => line.id === originalId);
          const maxQuantity = lineChange.originQuantity || 0;

          const lineSameOrigin = newList.filter(
            line => line.originalId === originalId && line.itemNo !== id
          );

          let totalQuantity = value || 0;

          lineSameOrigin.forEach(line => {
            const lineQuantity = line.quantity || 0;
            line.errorQuantity = false;
            totalQuantity += parseInt(lineQuantity, 10);
          });
          lineChange.errorQuantity = !value || totalQuantity > maxQuantity;
          if (lineChange.errorQuantity) {
            lineChange.errorText = "โปรดระบุจำนวนไม่เกินจำนวนตั้งต้น";
          }
          originLine.itemQty = originLine.originQuantity - totalQuantity;
          if (originLine.itemQty < 0) {
            originLine.itemQty = 0;
          }
        }
        if (lineChange.orderType.substring(0, 3).toUpperCase() === "CTP") {
          const originalId = lineChange.originalId;
          const originLine = newList.find(line => line.id === originalId);
          const maxQuantity = parseInt(lineChange.assignQuantity, 10) || 0;
          const lineSameOrigin = newList.filter(
            line => line.originalId === originalId && line.itemNo !== id
          );
          let totalQuantity = value || 0;
          lineSameOrigin.forEach(line => {
            const lineQuantity = line.quantity || 0;
            line.errorQuantity = false;
            totalQuantity += parseInt(lineQuantity, 10);
          });

          lineChange.errorQuantity = !value || totalQuantity > maxQuantity;
          if (lineChange.errorQuantity) {
            lineChange.errorText = "โปรดระบุจำนวนไม่เกิน Assigned quantity";
          }

          originLine.itemQty = originLine.originQuantity - totalQuantity;
          if (originLine.itemQty < 0) {
            originLine.itemQty = 0;
          }
        }
      } else {
        const remain = lineChange.remainWeight || 0;
        let total = 0;
        const key = `${lineChange.contractProductId}`;
        newList.forEach(line => {
          const lineKey = `${line.contractProductId}`;
          if (line.isNewAddItem) {
            if (line.itemNo === id) {
              total += lineChange.weightBase * newValue;
              return;
            }
            if (lineKey === key) {
              total += line.weightBase * line.quantity;
            }
          }
        });
        lineChange.errorQuantity = !value || total > remain;

        newList.forEach(line => {
          const lineKey = `${line.contractProductId}`;
          if (lineKey === key) {
            if (total <= remain && line.quantity) {
              line.errorQuantity = false;
            }
          }
        });
      }
    }
    if (field === "requestDate") {
      lineChange.errorDate =
        !newValue ||
        moment(newValue)
          .set("h", 1)
          .isBefore(moment().set("h", 0));
    }
    if (field === "plant") {
      lineChange.errorPlant = !newValue;
    }

    lineChange[field] = extraValue || newValue;
    lineChange.isChange = true;

    setListLineOrder(newList);
  };

  const [
    passParameter,
    { loading: loadingPassParameter }
  ] = usePassParameterToIPlanMutation();

  const onSaveInputParameter = inquiryMethod => {
    const tempLine = [...listLineOrder];
    const lineChange = tempLine.find(item => item.id === dataInputParameter);
    lineChange.inquiryMethod = inquiryMethod;
    setListLineOrder(tempLine);
    if (!loadingPassParameter) {
      passParameter({
        variables: {
          orderLineId: dataInputParameter,
          inquiryMethodCode: inquiryMethod
        }
      }).then(result => {
        if (result?.data?.passParameterToIPlan?.status) {
          setOpenInputParameter(false);
          setDataInputParameter(null);
        }
      });
    }
  };

  const [deleteNewlyItem] = useDeleteNewlyAddedOrderLineMutation({
    variables: {
      soNo,
      listItemNo: [itemNoDelete]
    },
    onError: () => {
      // Intentionally empty to prevent default error handling.
    }
  });

  const handleDeleteItem = (itemNo: string) => {
    setItemNoDelete(itemNo);
    setOpenDelete(true);
  };

  const handleConfirmDelete = () => {
    if (itemNoDelete) {
      deleteNewlyItem().then((newlyItem: any) => {
        const hasCheckoutOutdatedError =
          !newlyItem.data &&
          newlyItem?.errors.message === ErrorFields.CHECKOUT_OUTDATED_ERROR;
        if (hasCheckoutOutdatedError) {
          onConfirmReloadPage(true);
        } else {
          setListLineOrder(prev => {
            const newList = prev.filter(line => line.itemNo !== itemNoDelete);
            newList.map(item => {
              if (item.itemNo > itemNoDelete) {
                item.itemNo -= 10;
              }
              return item;
            });
            return newList;
          });
        }
      });
    }
    setOpenDelete(false);
  };

  const getListCheckedUnlimited = listLineOrder.filter(
    item => item.deliveryTolUnlimited
  );

  const getCheckedSelectAllUnlimited = () => {
    const listLineFilterDisable = listLineOrder.filter(
      item => !isItemDisabled(item) && !item.hasSplit && !item.isSplit
    );
    const listCheckedFilterDisable = getListCheckedUnlimited.filter(
      item => !isItemDisabled(item) && !item.hasSplit && !item.isSplit
    );
    return (
      listLineFilterDisable.length > 0 &&
      listLineFilterDisable.length === listCheckedFilterDisable.length
    );
  };

  const handleClickCheckBoxUnlimitedAll = () => {
    const newLine = [...listLineOrder];
    if (getCheckedSelectAllUnlimited()) {
      newLine
        .filter(
          item => !isItemDisabled(item) && !item.hasSplit && !item.isSplit
        )
        .forEach(item => (item.deliveryTolUnlimited = false));
    } else {
      newLine
        .filter(
          item => !isItemDisabled(item) && !item.hasSplit && !item.isSplit
        )
        .forEach(item => (item.deliveryTolUnlimited = true));
    }
    setListLineOrder(newLine);
  };

  const isItemDisabled = item =>
    item.statusCancel === "Cancel" ||
    item.statusCancel === "Delete" ||
    !item.isNewAddItem;

  const handleChangeRoute = (route, itemId) => {
    const value = {
      target: {
        value: route
      }
    };
    handleChangeField(value, itemId, "route");
  };

  const isK01K09 = item =>
    item.contractProduct?.matGroup1.includes("K01") ||
    item.contractProduct?.matGroup1.includes("K09");

  const isProdCateg1 = item => PROD_CATEG_1(item?.materialGroup1);

  const calculateWeight = item => {
    const weightFactor = item.isNewAddItem ? item.weight : item.saleQtyFactor;
    const weightUnit = item.isNewAddItem ? item.weightUnit : item.weightUnitTon;
    const isTon = weightUnit === WEIGHT_UNIT.TON;
    let totalWeight = 0;
    if (item.isNewAddItem) {
      totalWeight = isTon
        ? weightFactor * item.quantity
        : weightFactor * item.quantity * 1000;
    } else {
      totalWeight = isTon
        ? (weightFactor / 1000) * item.quantity
        : weightFactor * item.quantity;
    }

    return totalWeight;
  };

  const renderCellHeadA = (
    <>
      <TableCellHeader className={classNames(classes.colA0)} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Original Date" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classNames(classes.colA1)}
        rowSpan={2}
        textAlign={"center"}
      >
        <MyTypography variant={"subtitle3"} className={classes.textRequestDate}>
          {intl.formatMessage({ defaultMessage: "Request Date" })}
          <span className={classes.requiredMark}>*</span>
        </MyTypography>
        <DatePickerApplyAll
          onApplyAll={handleApplyAllRequestDate}
          minDate={moment()}
        />
      </TableCellHeader>
      <TableCellHeader
        className={classNames(classes.colA2Add)}
        rowSpan={2}
        textAlign={"left"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({
            defaultMessage: "Reason for Change Request Date"
          })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colA3} rowSpan={2}>
        <MyTypography variant={"subtitle3"} className={classes.textConfirmDate}>
          {intl.formatMessage({ defaultMessage: "Confirm Date" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classNames(classes.colA4Add, classes.noBorderRight)}
        rowSpan={2}
        textAlign={"left"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "จำนวน" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classNames(classes.col5Add, classes.noBorderLeft)}
        rowSpan={2}
        textAlign={"left"}
      >
        <MyTypography variant={"body3"}>
          {intl.formatMessage({ defaultMessage: "หน่วย" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classNames(classes.colA6, classes.noBorderRight)}
        rowSpan={2}
        textAlign={"center"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "น้ำหนัก" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classNames(classes.colA7, classes.noBorderLeft)}
        rowSpan={2}
        textAlign={"left"}
      >
        <MyTypography variant={"body3"}>
          {intl.formatMessage({ defaultMessage: "หน่วย" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classes.colA8}
        rowSpan={2}
        textAlign={"center"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Plant" })}
        </MyTypography>
        <Button
          data-testid="plantApplyAllButton"
          className={classes.btnApplyAllAdd}
          onClick={setApplyPlant}
          variant={"contained"}
        >
          <MyTypography variant={"caption"}>Apply all</MyTypography>
        </Button>
      </TableCellHeader>

      <TableCellHeader
        className={classNames(classes.colA22, classes.noBorderRight)}
        textAlign={"center"}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Assign Qty." })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classNames(classes.colA23, classes.noBorderLeft)}
        textAlign={"center"}
        rowSpan={2}
      >
        <MyTypography variant={"body3"}>
          {intl.formatMessage({ defaultMessage: "หน่วย" })}
        </MyTypography>
      </TableCellHeader>

      <TableCellHeader
        className={classes.colA9}
        rowSpan={2}
        textAlign={"right"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "ราคา/หน่วย" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classes.colA10}
        rowSpan={2}
        textAlign={"right"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "ราคารวมสุทธิ" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classes.colA11}
        rowSpan={2}
        textAlign={"center"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Currency" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colA12} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "เงื่อนไขการชำระเงิน" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classes.colA13}
        rowSpan={2}
        textAlign={"center"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Item Cat." })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classes.colA14}
        rowSpan={2}
        textAlign={"center"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Shipping Point" })}
        </MyTypography>
        <Button
          data-testid="shippingPointApplyAllButton"
          className={classes.btnApplyAllAdd}
          onClick={setApplyShippingPoint}
          variant={"contained"}
        >
          <MyTypography variant={"caption"}>Apply all</MyTypography>
        </Button>
      </TableCellHeader>
      <TableCellHeader
        className={classes.colA15}
        rowSpan={2}
        textAlign={"center"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Route" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colA16} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "วันที่ออก PO" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colA17} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "PO No." })}
        </MyTypography>
      </TableCellHeader>

      <TableCellHeader className={classes.colA25} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "PR No." })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colA26} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "PR Item" })}
        </MyTypography>
      </TableCellHeader>

      <TableCellHeader className={classes.colA18} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "PO No." })}{" "}
          <span className={classes.normalText}>(Outsource)</span>
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colA18} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Item Status" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader colSpan={3} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Delivery Tolerance" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colA18} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Product Group" })}
        </MyTypography>
      </TableCellHeader>
    </>
  );

  const renderCellHeadC = (
    <>
      <TableCellHeader className={classes.colC1} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Ship-to Party" })}
        </MyTypography>
      </TableCellHeader>
      {/* <TableCellHeader className={classes.colC4} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({
            defaultMessage: "Internal Comments to Logistic"
          })}
        </MyTypography>
      </TableCellHeader> */}
      <TableCellHeader className={classes.colC2} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({
            defaultMessage: "Internal Comments to Warehouse"
          })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colC3} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({
            defaultMessage: "External Comments to Customer"
          })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colC3} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({
            defaultMessage: "Remark"
          })}
        </MyTypography>
      </TableCellHeader>
      {/* <TableCellHeader className={classes.colC5} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Production information" })}
        </MyTypography>
      </TableCellHeader> */}
    </>
  );

  const renderCellBodyA = item => (
    <>
      <TableCell>
        <MyTypography variant={"body3"}>
          {item?.originalRequestDate || "-"}
        </MyTypography>
      </TableCell>
      <TableCell align={"left"}>
        {isItemDisabled(item) ? (
          <MyTypography variant={"body3"} className={classes.disabledLine}>
            {item.requestDate
              ? moment(item.requestDate).format("DD/MM/YYYY")
              : ""}
          </MyTypography>
        ) : (
          <DatePicker
            name={"requestDate"}
            data-testid="requestDate-input"
            value={item.requestDate}
            onChange={e => handleChangeField(e, item.itemNo, "requestDate")}
            noBlock
            error={item.errorDate}
            minDate={moment()}
            disabled={
              item.isNewAddItem
                ? false
                : item.hasSplit || isOrderCompletedDelivery
            }
          />
        )}
      </TableCell>
      <TableCell
        className={classes.noBorderLeft}
        align={isItemDisabled(item) ? "center" : "left"}
      >
        {isItemDisabled(item) ? (
          <MyTypography variant={"body3"}>
            {item.requestDateChangeReason}
          </MyTypography>
        ) : (
          <SingleSelectField
            disabled={
              item.isNewAddItem
                ? false
                : item.hasSplit || isOrderCompletedDelivery || item.isSplit
            }
            name={"requestDateChangeReason"}
            InputProps={{
              inputProps: {
                "data-testid": "requestDateChangeReason-input"
              }
            }}
            placeholder={"Select"}
            choices={[
              {
                value: ReasonForChangeRequestDateEnum.X,
                label: "None"
              },
              {
                value: ReasonForChangeRequestDateEnum.C3,
                label: "C3-Logistic"
              },
              { value: ReasonForChangeRequestDateEnum.C4, label: "C4-Customer" }
            ]}
            onChange={e =>
              handleChangeField(e, item.itemNo, "requestDateChangeReason")
            }
            value={
              item.requestDateChangeReason || ReasonForChangeRequestDateEnum.X
            }
          />
        )}
      </TableCell>
      <TableCell>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(item),
            [classes.wrongDate]: item.requestDate !== item.confirmedDate,
            [classes.matchDate]: item.requestDate === item.confirmedDate
          })}
        >
          {item.confirmedDate && !item.isSplit
            ? moment(item.confirmedDate).format("DD/MM/YYYY")
            : "-"}
        </MyTypography>
      </TableCell>

      <TableCell
        className={classNames(classes.noBorderRight, classes.colA4Add)}
      >
        {isItemDisabled(item) ? (
          <MyTypography variant={"body3"} className={classes.disabledLine}>
            <FormattedNumber
              value={item.itemQty}
              {...(SALE_CATEG_1(item?.salesUnit)
                ? { minimumFractionDigits: 3, maximumFractionDigits: 3 }
                : {})}
            />
          </MyTypography>
        ) : (
          <NumberFormat
            inputDisabled={
              item.isNewAddItem
                ? false
                : item.hasSplit || isOrderCompletedDelivery
            }
            allowNegative={false}
            allowLeadingZeros={!SALE_CATEG_1(item?.salesUnit)}
            value={item.itemQty}
            onChange={e => handleChangeField(e, item.itemNo, "quantity")}
            name={"quantity"}
            testId="quantity-input"
            error={item.errorQuantity || !item.quantity}
            placeholder={SALE_CATEG_1(item?.salesUnit) ? "0.000" : "0"}
            decimalScale={SALE_CATEG_1(item?.salesUnit) ? 3 : 0}
            rightAlignPlaceholder={SALE_CATEG_1(item?.salesUnit)}
            fixedDecimalScale={SALE_CATEG_1(item?.salesUnit)}
          />
        )}
        {item.errorQuantity && item.quantity ? (
          <div className={classes.errorText}>
            {item?.errorText
              ? item?.errorText
              : "จำนวนที่สั่งมีมากกว่าจำนวนคงเหลือ"}
          </div>
        ) : (
          ""
        )}
      </TableCell>
      <TableCell align={"left"} className={classes.noBorderLeft}>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(item)
          })}
        >
          {item?.salesUnit}
        </MyTypography>
      </TableCell>
      <TableCell align={"center"} className={classes.noBorderRight}>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(item)
          })}
        >
          {item.quantity ? (
            <DecimalFormat
              value={calculateWeight(item)}
              isGrayDecimal={false}
              countDecimal={3}
            />
          ) : (
            "0"
          )}
        </MyTypography>
      </TableCell>
      <TableCell className={classes.noBorderLeft}>
        {isItemDisabled(item) ? (
          <MyTypography variant={"body3"} className={classes.disabledLine}>
            {item.weightUnitTon}
          </MyTypography>
        ) : (
          <SingleSelectField
            disabled={item.hasSplit || item.isSplit}
            InputProps={{
              classes: { input: classes.txtInputSelect },
              inputProps: {
                "data-testid": "weightUnit-input"
              }
            }}
            choices={[
              {
                label: <MyTypography variant={"subtitle3"}>TON</MyTypography>,
                value: WEIGHT_UNIT.TON
              },
              {
                label: <MyTypography variant={"subtitle3"}>Kg.</MyTypography>,
                value: WEIGHT_UNIT.KG
              }
            ]}
            onChange={e => handleChangeField(e, item.itemNo, "weightUnit")}
            placeholder={"Select"}
            value={item.weightUnit}
            name={"weightUnit"}
          />
        )}
      </TableCell>
      <TableCell align={"center"}>
        {isItemDisabled(item) ? (
          <MyTypography variant={"body3"} className={classes.disabledLine}>
            {item.plant}
          </MyTypography>
        ) : (
          <SingleTextField
            disabled={
              item.isNewAddItem
                ? false
                : item.hasSplit || isOrderCompletedDelivery || item.isSplit
            }
            name={"plant"}
            InputProps={{
              inputProps: {
                "data-testid": "plant-input"
              }
            }}
            value={item.plant}
            onChange={e => handleChangeField(e, item.itemNo, "plant")}
            maxLengthProps={4}
            regex={REGEX_ONLY_NUMBER_CHARACTER}
          />
        )}
      </TableCell>

      <TableCell align={"center"} className={classes.noBorderRight}>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(item)
          })}
        >
          {item?.isNewAddItem ? (
            ""
          ) : (
            <FormattedNumber
              value={
                isKO1KO9(item?.materialGroup1)
                  ? item?.assignQuantity
                  : item?.comfirmQty
              }
            />
          )}
        </MyTypography>
      </TableCell>
      <TableCell align={"center"} className={classes.noBorderLeft}>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(item)
          })}
        >
          {item?.isNewAddItem ? "" : item?.salesUnit}
        </MyTypography>
      </TableCell>

      <TableCell align={"right"}>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(item)
          })}
        >
          <DecimalFormat
            value={item?.pricePerUnit}
            isGrayDecimal={false}
            countDecimal={2}
          />
        </MyTypography>
      </TableCell>
      <TableCell align={"right"}>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(item)
          })}
        >
          <DecimalFormat
            value={
              isProdCateg1
                ? getTotalNetPriceByLine(item)
                : getTotalNetPriceByLineNewProductGroup(item)
            }
            isGrayDecimal={false}
            countDecimal={2}
          />
        </MyTypography>
      </TableCell>
      <TableCell align={"center"}>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(item)
          })}
        >
          {dataOrder?.currency || ""}
        </MyTypography>
      </TableCell>
      <TableCell>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(item)
          })}
        >
          {item.paymentTerm}
        </MyTypography>
      </TableCell>
      <TableCell>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(item)
          })}
        >
          {item.itemCategory}
        </MyTypography>
      </TableCell>
      <TableCell align={"center"}>
        {isItemDisabled(item) ? (
          <MyTypography variant={"body3"} className={classes.disabledLine}>
            {item.shippingPoint}
          </MyTypography>
        ) : (
          <SingleTextField
            disabled={item.hasSplit || item.isSplit}
            value={item.shippingPoint}
            name={"shippingPoint"}
            InputProps={{
              inputProps: {
                "data-testid": "shippingPoint-input"
              }
            }}
            onChange={e => handleChangeField(e, item.itemNo, "shippingPoint")}
            maxLengthProps={4}
          />
        )}
      </TableCell>
      <TableCell>
        <div className={classes.rowFlex}>
          {isItemDisabled(item) ? (
            <MyTypography variant={"body3"} className={classes.disabledLine}>
              {item.route}
            </MyTypography>
          ) : (
            <SearchRoute
              route={item.route}
              setRoute={handleChangeRoute}
              contractNo={dataOrder?.contractNo}
              disabled={item.hasSplit || item.isSplit}
              itemId={item.itemNo}
              btnClsNames={classes.searchbtn}
            />
          )}
        </div>
      </TableCell>
      <TableCell>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(item)
          })}
        >
          {dataOrder?.orderItems[0]?.poDate
            ? moment(dataOrder?.orderItems[0]?.poDate).format("DD/MM/YYYY")
            : ""}
        </MyTypography>
      </TableCell>
      <TableCell>
        {isItemDisabled(item) ? (
          <MyTypography variant={"body3"} className={classes.disabledLine}>
            {item.poNo}
          </MyTypography>
        ) : (
          <SingleTextField
            disabled={item.hasSplit || item.isSplit}
            onChange={e => handleChangeField(e, item.itemNo, "poNo")}
            value={item.poNo}
            name={"poNo"}
            InputProps={{
              inputProps: {
                "data-testid": "poNo-input"
              }
            }}
          />
        )}
      </TableCell>

      <TableCell>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(item)
          })}
        >
          {item?.prNo ?? ""}
        </MyTypography>
      </TableCell>

      <TableCell>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(item)
          })}
        >
          {item?.prItem ?? ""}
        </MyTypography>
      </TableCell>

      <TableCell>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(item)
          })}
        >
          {item.poNoExternal}
        </MyTypography>
      </TableCell>
      <TableCell>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(item)
          })}
        >
          {item.itemStatusEnDisplayText || ""}
        </MyTypography>
      </TableCell>
      <TableCell align={"center"} className={classes.noBorderRight}>
        {isItemDisabled(item) ? (
          <MyTypography variant={"body3"} className={classes.disabledLine}>
            {item.underDeliveryTol}
          </MyTypography>
        ) : (
          <SingleTextFieldUnblock
            placeholder={"Under"}
            onChange={e =>
              handleChangeField(e, item.itemNo, "underDeliveryTol")
            }
            value={
              isK01K09(item) || item.deliveryTolUnlimited
                ? "0"
                : item.underDeliveryTol
            }
            name={"underDeliveryTol"}
            InputProps={{
              inputProps: {
                "data-testid": "underDeliveryTol-input"
              }
            }}
            className={classes.inputUnlimit}
            regex={REGEX_ONLY_NUMBER}
            disabled={
              item.deliveryTolUnlimited || item.hasSplit || item.isSplit
            }
            numberLimit={100}
          />
        )}
      </TableCell>
      <TableCell
        align={"center"}
        className={classNames(classes.noBorderRight, classes.noBorderLeft)}
      >
        {isItemDisabled(item) ? (
          <MyTypography variant={"body3"} className={classes.disabledLine}>
            {item.overDeliveryTol}
          </MyTypography>
        ) : (
          <SingleTextFieldUnblock
            placeholder={"Over"}
            onChange={e => handleChangeField(e, item.itemNo, "overDeliveryTol")}
            value={
              isK01K09(item) || item.deliveryTolUnlimited
                ? "0"
                : item.overDeliveryTol
            }
            name={"overDeliveryTol"}
            InputProps={{
              inputProps: {
                "data-testid": "overDeliveryTol-input"
              }
            }}
            className={classes.inputUnlimit}
            regex={REGEX_ONLY_NUMBER}
            disabled={
              item.deliveryTolUnlimited || item.hasSplit || item.isSplit
            }
            numberLimit={100}
          />
        )}
      </TableCell>
      <TableCell align={"center"} className={classes.noBorderLeft}>
        <MyTypography
          variant={"body3"}
          className={classNames(classes.cellFlexCenter, {
            [classes.disabledLine]: isItemDisabled(item)
          })}
        >
          <Checkbox
            onChange={e =>
              handleChangeField(
                e,
                item.itemNo,
                "deliveryTolUnlimited",
                e.target.checked
              )
            }
            checked={item.deliveryTolUnlimited}
            className={classNames(classes.checkBoxDisabled, "colCheck")}
            disabled={isItemDisabled(item) || item.hasSplit || item.isSplit}
          />
          Unlimited
        </MyTypography>
      </TableCell>
      <TableCell>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(item)
          })}
        >
          {(item?.materialGroup1 ?? item?.contractProduct?.matGroup1) +
            `: ` +
            (item?.materialGroup1Desc ?? item?.contractProduct?.matGroup1Desc)}
        </MyTypography>
      </TableCell>
    </>
  );
  const renderCellBodyC = item => (
    <>
      <TableCell>
        <div className={classes.rowFlexSpace}>
          <pre
            style={{
              wordWrap: "break-word",
              whiteSpace: "pre-wrap",
              margin: 0
            }}
          >
            <MyTypography
              variant={"body3"}
              className={classNames({
                [classes.disabledLine]: isItemDisabled(item)
              })}
            >
              {item?.shipTo ? item?.shipTo : ""}
            </MyTypography>
          </pre>
          {!isItemDisabled(item) &&
          shipToData?.getSapRealtimePartner?.response.length > 1 ? (
            <Button
              variant={"outlined"}
              color={"secondary"}
              className={classes.btnThin}
              onClick={() => handleOpenAddress(item)}
              disabled={item.hasSplit || item.isSplit}
            >
              <MyTypography variant={"body3"}>
                {intl.formatMessage({ defaultMessage: "แก้ไข" })}
              </MyTypography>
            </Button>
          ) : (
            ""
          )}
        </div>
      </TableCell>
      {/* <TableCell>
        {renderInternalAndExternalComment("internalCommentsToLogistic", item)}
      </TableCell> */}
      <TableCell>
        {renderInternalAndExternalComment("internalCommentsToWarehouse", item)}
      </TableCell>
      <TableCell>
        {renderInternalAndExternalComment("externalCommentsToCustomer", item)}
      </TableCell>
      <TableCell>
        {renderInternalAndExternalComment("shippingMark", item)}
      </TableCell>
      {/* <TableCell>
        {renderInternalAndExternalComment("productInformation", item)}
      </TableCell> */}
    </>
  );

  return (
    <div className={classes.root}>
      <div className={classes.topBox}>
        <FullScreenButton />
      </div>
      <div className={classes.tabBox}>
        {renderCollection(tabList, tab => {
          if (tab.code === ItemTab.tabD && !isCashSaleOrder) {
            return null;
          }

          return (
            <div
              key={tab.code}
              className={classNames(
                activeTab === tab.code ? classes.zMax : classes[tab.index]
              )}
            >
              <Button
                id={tab.id}
                data-testid={tab.id}
                onClick={() => onTabClick(tab.code)}
                onKeyDown={e => {
                  if (e.key === "Enter" || e.key === " ") {
                    onTabClick(tab.code);
                  }
                }}
                className={classNames(
                  !tab.first && classes.tabB,
                  classes.tableTab,
                  activeTab === tab.code
                    ? classes.tableTabActive
                    : classes.tableTabInactive
                )}
              >
                <MyTypography
                  variant={"body2"}
                  className={classNames(
                    activeTab === tab.code
                      ? classes.innerTabActive
                      : classes.innerTab
                  )}
                >
                  {tab.title}
                </MyTypography>
              </Button>
            </div>
          );
        })}
      </div>

      {[ItemTab.tabA, ItemTab.tabB, ItemTab.tabC].includes(activeTab) ? (
        <>
          <div className={classes.boxTable} ref={containerRef}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCellHeader
                    className={classes.cellFrezze1Add}
                    rowSpan={activeTab === ItemTab.tabA ? 2 : 1}
                    direction={
                      sort.sort === DomesticOrderSortField.item_no
                        ? getArrowDirection(sort.asc)
                        : undefined
                    }
                    arrowPosition="right"
                    onClick={() => onSort(DomesticOrderSortField.item_no)}
                  >
                    <MyTypography variant={"subtitle3"}>
                      {intl.formatMessage({ defaultMessage: "Item No." })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader
                    className={classes.cellFrezze2Add}
                    rowSpan={activeTab === ItemTab.tabA ? 2 : 1}
                  >
                    <MyTypography variant={"subtitle3"}>
                      {intl.formatMessage({ defaultMessage: "Material Code" })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader
                    className={classes.cellFrezze3Add}
                    rowSpan={activeTab === ItemTab.tabA ? 2 : 1}
                  >
                    <MyTypography variant={"subtitle3"}>
                      {intl.formatMessage({
                        defaultMessage: "Material Description."
                      })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader
                    className={classes.cellFrezze4Add}
                    rowSpan={activeTab === ItemTab.tabA ? 2 : 1}
                  />
                  {activeTab === ItemTab.tabA && renderCellHeadA}
                  {activeTab === ItemTab.tabC && renderCellHeadC}
                </TableRow>
                {activeTab === ItemTab.tabA && (
                  <TableRow>
                    <TableCell
                      align={"center"}
                      className={classNames(
                        classes.colA19,
                        classes.noBorderRight,
                        classes.cellUnlimited
                      )}
                    >
                      <MyTypography
                        variant={"body3"}
                        className={classes.cellSize13}
                      >
                        Under (%)
                      </MyTypography>
                    </TableCell>
                    <TableCell
                      align={"center"}
                      className={classNames(
                        classes.colA20,
                        classes.noBorderRight,
                        classes.noBorderLeft,
                        classes.cellUnlimited
                      )}
                    >
                      <MyTypography
                        variant={"body3"}
                        className={classes.cellSize13}
                      >
                        Over (%)
                      </MyTypography>
                    </TableCell>
                    <TableCell
                      align={"center"}
                      className={classNames(
                        classes.colA21,
                        classes.noBorderLeft,
                        classes.cellUnlimited,
                        classes.cellHeadCheck
                      )}
                    >
                      <MyTypography
                        variant={"body3"}
                        className={classNames(
                          classes.cellSize13,
                          classes.cellFlexCenter
                        )}
                      >
                        <Checkbox
                          className="colCheck"
                          disabled={true}
                          checked={false}
                          onClick={handleClickCheckBoxUnlimitedAll}
                          // indeterminate={getIndeterminateAllLimit()}
                          // checked={getCheckedSelectAllUnlimited()}
                        />
                        Unlimited
                      </MyTypography>
                    </TableCell>
                  </TableRow>
                )}
              </TableHead>
              <TableBody>
                {currentData
                  .filter(orderItem => orderItem.statusCancel !== "Delete")
                  .map(item => (
                    <TableRow
                      key={item.itemNo}
                      className={classNames({
                        [classes.disabledLine]: isItemDisabled(item)
                      })}
                    >
                      <TableCell
                        className={classes.cellFrezze1Add}
                        align={"center"}
                      >
                        <MyTypography
                          variant={"body3"}
                          className={classNames({
                            [classes.disabledLine]: isItemDisabled(item)
                          })}
                        >
                          {item.isSplit ? "-" : item.itemNo}
                        </MyTypography>
                      </TableCell>
                      <TableCell className={classes.cellFrezze2Add}>
                        <MyTypography
                          variant={"body3"}
                          className={classNames({
                            [classes.disabledLine]: isItemDisabled(item)
                          })}
                        >
                          {item?.material}
                        </MyTypography>
                      </TableCell>
                      <TableCell className={classes.cellFrezze3Add}>
                        <MyTypography
                          variant={"body3"}
                          className={classNames({
                            [classes.disabledLine]: isItemDisabled(item)
                          })}
                        >
                          {item?.materialDesc}
                        </MyTypography>
                        {isItemDisabled(item) && (
                          <MyTypography
                            variant={"caption"}
                            className={classNames({
                              [classes.boxCancel]:
                                item.statusCancel === "Cancel"
                              // [classes.boxDelete]: item.statusCancel === "Delete"
                            })}
                          >
                            {item.statusCancel === "Cancel" ? "Cancel 93" : ""}
                          </MyTypography>
                        )}
                      </TableCell>
                      <TableCell
                        className={classes.cellFrezze4Add}
                        align={"center"}
                      >
                        {item.isNewAddItem ? (
                          <SVG
                            data-testid="deleteItemButton"
                            src={TrashCan}
                            cursor="pointer"
                            onClick={() => handleDeleteItem(item.itemNo)}
                          />
                        ) : (
                          ""
                        )}
                      </TableCell>
                      {activeTab === ItemTab.tabA && renderCellBodyA(item)}
                      {activeTab === ItemTab.tabC && renderCellBodyC(item)}
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
            <StickyHorizontalScrollBar
              container={containerRef}
              reRender={reRender}
              // bottom={fullScreen ? 0 : 173}
            />
          </div>
          <TablePaginationCustom
            hasNextPage={loading || hasNextPage}
            hasPreviousPage={loading || hasPreviousPage}
            onNextPage={onNextPage}
            onPreviousPage={onPreviousPage}
            totalCount={currentData.length}
            selectColor="#007E92"
            settings={settings}
            onUpdateListSettings={onUpdateListSettings}
            isBackFistPage
            isNextLastPage
            latestPageItemNumber={currentData.length}
            onNextLastPage={onNextLastPage}
            onPreviousFirstPage={onPreviousFirstPage}
            disabled={loading}
            rowNumberSet={BIG_ROW_NUMBER_SET}
          />
        </>
      ) : activeTab === ItemTab.tabD && cashSaleFormProps ? (
        <CashSaleForm {...cashSaleFormProps} />
      ) : null}

      <ModalAddress
        address={shipToData?.getSapRealtimePartner?.response || []}
        handleApplyAddress={applyAddressShipTo}
        initAddress={dataModalAddress.initAddress}
        visible={openAddress}
        onClose={handleCloseAddress}
      />
      <PopoverApplyAll
        key={`apply_${componentKey}`}
        title={dataApplyAll.title}
        onOk={handleApplyAll}
        open={openApplyAll}
        onClose={() => setOpenApplyAll(false)}
        anchorEl={dataApplyAll.anchorEl}
        placeholder={dataApplyAll.placeholder}
        maxLengthInput={dataApplyAll.maxLength}
        regexInput={dataApplyAll.regex}
      />
      <ModalInputParameter
        loading={loadingPassParameter}
        open={openInputParameter}
        onClose={() => setOpenInputParameter(false)}
        onSave={onSaveInputParameter}
        initialValue={
          listLineOrder.find(item => item.id === dataInputParameter)
            ?.inquiryMethod
        }
        orderId={dataInputParameter}
      />
      <DialogConfirmDelete
        onConfirm={handleConfirmDelete}
        onCancel={() => setOpenDelete(false)}
        open={openDelete}
        title={
          <span className={classes.titleDelete}>
            Delete item สินค้าที่เลือก
          </span>
        }
        cancelText={"กลับไป"}
        okText={"ยืนยัน"}
        content={
          <MyTypography variant={"body2"}>
            {intl.formatMessage({
              defaultMessage:
                'กรุณากด "ยืนยัน" เพื่อลบรายการสินค้าที่เลือก หรือกด กลับไป" เพื่อปิดหน้าต่างนี้'
            })}
          </MyTypography>
        }
      />
    </div>
  );
};

export default AddNewItem;
